var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#icon-logedin-user-icon-71ed4';
                    var viewUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#view-icon-logedin-user-icon-71ed4';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };